module.exports = __webpack_public_path__ + "static/media/28DGC2.0510beae.jpg";